export enum HrZonesType {
    Max = 1,
    Auto = 2,
    Manual = 3
}
